/**
 * Browser stub for the firebase-admin package.
 *
 * firebase-admin is Node.js only. Vite aliases this package to this stub
 * so the Admin SDK never enters the client bundle.
 *
 * firestoreAdmin.ts runs `if (!admin.apps.length) admin.initializeApp()` at
 * module load time, so initializeApp() must be a no-op (not a throw).
 * Data methods (firestore.collection, etc.) throw if somehow reached at runtime.
 */

const DATA_NOT_AVAILABLE = (name: string) => () => {
  throw new Error(`[firebase-admin stub] "${name}" is not available in the browser. This is a server-side API.`);
};

// Mock Firestore instance — throws only if data methods are actually called
const firestoreInstance = {
  collection: DATA_NOT_AVAILABLE('firestore.collection'),
  doc: DATA_NOT_AVAILABLE('firestore.doc'),
  runTransaction: DATA_NOT_AVAILABLE('firestore.runTransaction'),
  batch: DATA_NOT_AVAILABLE('firestore.batch'),
  settings: () => {},
} as unknown as FirebaseFirestore.Firestore;

// Mock app — returned by initializeApp, used by admin.firestore()
const mockApp = { name: '[browser-stub]', options: {} };

// apps array starts with the mock app so `apps.length` is truthy →
// firestoreAdmin.ts's `if (!admin.apps.length) initializeApp()` is skipped
export const apps: unknown[] = [mockApp];

export function initializeApp(): typeof mockApp {
  return mockApp;
}

// admin.firestore() — called once in firestoreAdmin.ts to get the db instance
export function firestore(): typeof firestoreInstance {
  return firestoreInstance;
}
// Static helpers accessed as firestore.FieldValue, firestore.Timestamp, etc.
(firestore as any).FieldValue = {};
(firestore as any).Timestamp = {};

export const auth = () => ({});
export const storage = () => ({});
export const credential = {
  cert: () => ({}),
  applicationDefault: () => ({}),
};

export default {
  apps,
  initializeApp,
  firestore,
  auth,
  storage,
  credential,
};
